import React from 'react';
import './App.css';
import { useRef, useEffect, useState, useCallback } from 'react';
import { Slider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import * as mm from "@magenta/music";

import data from './rhythmsi.json'
// console.log(data)

export default function Complexetron() {

    const rhythms = Object.values(data)

    const [numNotes, setNumNotes] = useState(4)
    const [complexity, setComplexity] = useState(0)
    const [tempo, setTempo] = useState(110)
    const [onsets, setOnsets] = useState([1,1,1,0,0,1,0,1,0,0,1,0,1,0,0,0])
    const [numOptions, setNumOptions] = useState(0)
    const [options, setOptions] = useState([])
    const [currOption, setCurrOption] = useState(0)
    const [rNum, setRNum] = useState(0)
    const [optionText, setOptionText] = useState('')
    const [metronome, setMetronome] = useState(false)
    const [swap, setSwap] = useState(false)
    const [swapText,setSwapText] = useState('Cycle')
    const [playText,setPlayText] = useState("▶️ Play")
    const [metronomeText,setMetronomeText] = useState('🕛 On')
    const [visualizer, setVisualizer] = useState({});
    const [playerReady, setPlayerReady] = useState(false)
    const [playerSaidStop, setPlayerSaidStop] = useState(true)
    const [player, setPlayer] = useState({});
    const [players, setPlayers] = useState({});
    const [endLoop, setEndLoop] = useState(false);
    const [startLoop, setStartLoop] = useState(false);
    const [playing, setPlaying] = useState(false);


    const velocities = [110,50,70,50,80,50,70,50,95,50,70,50,80,50,70,50]

    const [noteArray, setNoteArray] = useState({
        notes:[],
        quantizationInfo:{stepsPerQuarter:4},
        tempo: tempo,
        totalQuantizedSteps:16
        });

    const FULL_TWINKLE = {notes: [
            {pitch: 75, velocity: 1, quantizedStartStep: 0, quantizedEndStep: 1, program: 0, isDrum:true},
            {pitch: 75, velocity: 1, quantizedStartStep: 1, quantizedEndStep: 2, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 2, quantizedEndStep: 3, program: 0, isDrum:true},
            {pitch: 75, velocity: 0, quantizedStartStep: 3, quantizedEndStep: 4, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 4, quantizedEndStep: 5, program: 0, isDrum:true},
            {pitch: 75, velocity: 50, quantizedStartStep: 5, quantizedEndStep: 6, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 6, quantizedEndStep: 7, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 7, quantizedEndStep: 8, program: 0, isDrum:true},
            {pitch: 75, velocity: 50, quantizedStartStep: 8, quantizedEndStep: 9, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 9, quantizedEndStep: 10, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 10, quantizedEndStep: 11, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 11, quantizedEndStep: 12, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 12, quantizedEndStep: 13, program: 0, isDrum:true},
            // {pitch: 75, velocity: 100, quantizedStartStep: 13, quantizedEndStep: 14, program: 0, isDrum:true},
            {pitch: 75, velocity: 100, quantizedStartStep: 14, quantizedEndStep: 15, program: 0, isDrum:true},
            {pitch: 75, velocity: 100, quantizedStartStep: 15, quantizedEndStep: 16, program: 0, isDrum:true},

            {pitch: 81, velocity: 70, quantizedStartStep: 0, quantizedEndStep: 1, program: 0, isDrum:true},
            {pitch: 80, velocity: 70, quantizedStartStep: 4, quantizedEndStep: 5, program: 0, isDrum:true},
            {pitch: 80, velocity: 70, quantizedStartStep: 8, quantizedEndStep: 9, program: 0, isDrum:true},
            {pitch: 80, velocity: 70, quantizedStartStep: 12, quantizedEndStep: 13, program: 0, isDrum:true},
        ],
        quantizationInfo:{stepsPerQuarter:4},
        tempo: tempo,
        totalQuantizedSteps:16
    };

    const marks1 = [
        {
            value: 0,
            label: '0',
        },
        {
            value: 16,
            label: '16',
        },
    ];

    const marks2 = [
        {
            value: 20,
            label: '20',
        },
        {
            value: 200,
            label: '200',
        },
    ];

    const getNumNotes=(e,val)=>{
        setNumNotes(val);
        // changeRhythm(val);
        // lookup(val);
    }

    const getComplexity=(e,val)=>{
        setComplexity(val);
        // lookup(val);
    }

    const getTempo=(e,val)=>{
        setTempo(val);
    }

    const changeRhythm=(val)=>{
        // console.log(val)
        var r =[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        var i = 0;
        for (i = 0; i < val; ++i) {
            r[i] = 1;
        }
        // console.log(r)
        setOnsets(r)
    }

    const lookup=()=> {
        let arr = [];
        for (let i = 0; i < rhythms.length; i++) {
            if (rhythms[i]['complexity'] == complexity && rhythms[i]['num_onsets'] == numNotes) {
                arr.push(i)
            }
        }
        setNumOptions(arr.length)
        setOptions(arr)
    }

    const picker=()=> {
        let curr = getRandomInt(options.length)
        if (options.length > 0) {
            setRNum(options[curr])
            setCurrOption(curr+1)
        }
        else {
            setRNum(0)
            setCurrOption(curr)
        }
    }

    const gen=() => {
        let na = [];
        if (metronome) {
            na = [{pitch: 81, velocity: 70, quantizedStartStep: 0, quantizedEndStep: 1, program: 0, isDrum:true},
                {pitch: 80, velocity: 70, quantizedStartStep: 4, quantizedEndStep: 5, program: 0, isDrum:true},
                {pitch: 80, velocity: 70, quantizedStartStep: 8, quantizedEndStep: 9, program: 0, isDrum:true},
                {pitch: 80, velocity: 70, quantizedStartStep: 12, quantizedEndStep: 13, program: 0, isDrum:true}]
        }
        if (options.length > 0) {
            let chosen = rhythms[options[currOption-1]]
            let r = [];
            for (let i = 0; i < 16; i++) {
                r.push(chosen[i])
                if (chosen[i] == 1) {
                    na.push({pitch: 75, velocity: velocities[i], quantizedStartStep: i, quantizedEndStep: i+1, program: 0, isDrum:true})
                }
            }
            setOnsets(r)

            setNoteArray({
                notes:na,
                quantizationInfo:{stepsPerQuarter:4},
                tempo: tempo,
                totalQuantizedSteps: 16,
            });
        }
        else {
            setOnsets([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
            setNoteArray({
                notes:[],
                quantizationInfo:{stepsPerQuarter:4},
                tempo: tempo,
                totalQuantizedSteps: 16,
            });
        }
    }

    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    const initPlayers=()=> {
        players.soundfont = new mm.SoundFontPlayer('https://storage.googleapis.com/magentadata/js/soundfonts/sgm_plus');
        players.soundfont.callbackObject = {
            run: (note) => {},
            stop: () => {}
        };
        setPlayer(players.soundfont)
        console.log('player init')
        setPlayerReady(true);
    }

    const stopPlayer=()=> {
        player.stop();
        setPlayText("▶️ Play");
        setPlayerSaidStop(true)
        // console.log('player stop')
    }

    const startPlayer=()=> {
        setPlayerSaidStop(false)
        // player.start(FULL_TWINKLE);
        setPlayText("⏹ Stop");
        // console.log('player start')
    };

    function loopPlayer() {
        if (playerSaidStop) {
            return
        }
        // player.start(noteArray,tempo)
        // let t = (tempo/60)*1000
        // console.log(t)
        // setTimeout(setEndLoop(true), t);
        // setPlaying(true)

        // function repeat() {}

        async function playNext() {
            console.log('play2', performance.now())
            await player.start(noteArray,tempo)
            console.log('play2', performance.now())
            setPlaying(false)
            setEndLoop(true)
        }

        playNext()

        // if (!player.isPlaying()){
            // playNext()
            // player.start(noteArray,tempo).then(() => {
            //     setPlaying(false)
            //     // if (swap) {
            //     //     picker()
            //     // }
            //     // loopPlayer()
            //     setEndLoop(true)
            // });
        // }
    }

    const play=() => {
        console.log('play')
        if (playerReady) {
            console.log('player ready')
            if (player.isPlaying()) {
                stopPlayer();
            } else {
                startPlayer();
                loopPlayer();
            }
        }
    };

    const switchMetronome=() => {
        if (metronome) {
            setMetronome(false)
            setMetronomeText('🕛 On')
        }
        else {
            setMetronome(true)
            setMetronomeText('🕛 Off')
        }
    }

    const switchSwap=() => {
        if (swap) {
            setSwap(false)
            setSwapText('Cycle')
        }
        else {
            setSwap(true)
            setSwapText('Keep')
        }
    }

    useEffect(() => {
        if (!endLoop) {
            return
        }
        setEndLoop(false)
        if (swap) {
            picker()
        }
        setStartLoop(true)
        },[endLoop])


    useEffect(() => {
        if (!startLoop) {
            return
        }
        setStartLoop(false);
        loopPlayer();
        // if (!playing) {
        //     loopPlayer();
        // }
    },[startLoop])

    useEffect(() => {
        initPlayers();
        lookup();
    }, [])

    useEffect(() => {
        if (!numOptions) {
            setOptionText('No valid rhythms! Try another combination...')
        }
        else {
            setOptionText(currOption + ' of ' + numOptions)
        }
    },[numOptions,currOption])

    useEffect(() => {
        picker();
    }, [options])

    useEffect(() => {
        gen();
    }, [currOption,rNum])

    useEffect(() => {
        gen();
    }, [metronome, tempo])


    useEffect(() => {
        if (!playerReady) {
            return
        }
        if (player.isPlaying()) {
            stopPlayer();
            startPlayer();
            loopPlayer();
        }
        else {
            loopPlayer();
        }
        setPlaying(true)
        },[noteArray])

    useEffect(() => {
        if (!playerReady) {
            return
        }
        if (!playerSaidStop){
            loopPlayer()
        }
    }, [playerSaidStop]);

    const downloadMidi=()=>{
        // let seq = visualizer.noteSequence;
        // noteArray.notes.forEach(n => n.velocity = 80);
        noteArray.controlChanges=[];
        const magentaMidi = mm.sequenceProtoToMidi(noteArray);
        const magentaFile = new Blob([magentaMidi], { type: 'audio/midi' })
        const magentaURL = URL.createObjectURL(magentaFile);
        window.location.assign(magentaURL);
    }

    return (
        <div>
            <h1>🥁 Complexetron 🥁️</h1>
            <p>Create a rhythm by choosing the number of notes and the metric complexity.</p>
            <div className='slider-grid'>
                <div>
                    <StyledEngineProvider injectFirst>
                        <Slider className="slider" value={numNotes} min={0} max={16} onChange={getNumNotes}  aria-label="Notes" valueLabelDisplay="on" marks={marks1}/>
                    </StyledEngineProvider>
                </div>
                <div>
                    <StyledEngineProvider injectFirst>
                        <Slider className="slider" value={complexity} min={0} max={16} onChange={getComplexity}  aria-label="Complexity" valueLabelDisplay="on" marks={marks1}/>
                    </StyledEngineProvider>
                </div>
                <div>
                    <StyledEngineProvider injectFirst>
                        <Slider className="slider" value={tempo} min={20} max={200} step={10} onChange={getTempo}  aria-label="Tempo" valueLabelDisplay="on" marks={marks2}/>
                    </StyledEngineProvider>
                </div>
                <div>Notes</div>
                <div>Complexity</div>
                <div>Tempo</div>
            </div>
            <div id='buttons'>
                <button onClick={lookup}>🔄 Generate</button>
                <button onClick={play}>{playText}</button>
                <button onClick={switchMetronome}>{metronomeText}</button>
                <button onClick={switchSwap}>{swapText}</button>
                {/*<button onClick={stopPlayer}>⏹ ️&nbsp; Stop</button>*/}
                <button onClick={downloadMidi}>💾 Save</button>
            </div>
            <p>{optionText}</p>
            <div className="grid-container">
                <div>{onsets[0] ? '⚫' : ' '}</div>
                <div>{onsets[1] ? '⚫' : ' '}</div>
                <div>{onsets[2] ? '⚫' : ' '}</div>
                <div>{onsets[3] ? '⚫' : ' '}</div>
                <div>{onsets[4] ? '⚫' : ' '}</div>
                <div>{onsets[5] ? '⚫' : ' '}</div>
                <div>{onsets[6] ? '⚫' : ' '}</div>
                <div>{onsets[7] ? '⚫' : ' '}</div>
                <div>{onsets[8] ? '⚫' : ' '}</div>
                <div>{onsets[9] ? '⚫' : ' '}</div>
                <div>{onsets[10] ? '⚫' : ' '}</div>
                <div>{onsets[11] ? '⚫' : ' '}</div>
                <div>{onsets[12] ? '⚫' : ' '}</div>
                <div>{onsets[13] ? '⚫' : ' '}</div>
                <div>{onsets[14] ? '⚫' : ' '}</div>
                <div>{onsets[15] ? '⚫' : ' '}</div>
            </div>
            <div className="grid-container3">
                <div>{metronome ? '🕛' : ' '}</div>
                <div></div>
                <div></div>
                <div></div>
                <div>{metronome ? '🕒' : ' '}</div>
                <div></div>
                <div></div>
                <div></div>
                <div>{metronome ? '🕕' : ' '}</div>
                <div></div>
                <div></div>
                <div></div>
                <div>{metronome ? '🕘' : ' '}</div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className="grid-container2">
                <div>◻️◻️◻️◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️◻️</div>
                <div>◻️</div>
                <div>◻️◻️</div>
                <div>◻️</div>
            </div>

        </div>
    );
}